__turbopack_context__.v({
  "flex_1": "o95yIq_flex_1",
  "flex_2": "o95yIq_flex_2",
  "flex_3": "o95yIq_flex_3",
  "flex_4": "o95yIq_flex_4",
  "flex_5": "o95yIq_flex_5",
  "flex_6": "o95yIq_flex_6",
  "flex_desktop_1": "o95yIq_flex_desktop_1",
  "flex_desktop_2": "o95yIq_flex_desktop_2",
  "flex_desktop_3": "o95yIq_flex_desktop_3",
  "flex_desktop_4": "o95yIq_flex_desktop_4",
  "flex_desktop_5": "o95yIq_flex_desktop_5",
  "flex_desktop_6": "o95yIq_flex_desktop_6",
  "flex_tablet_1": "o95yIq_flex_tablet_1",
  "flex_tablet_2": "o95yIq_flex_tablet_2",
  "flex_tablet_3": "o95yIq_flex_tablet_3",
  "flex_tablet_4": "o95yIq_flex_tablet_4",
  "flex_tablet_5": "o95yIq_flex_tablet_5",
  "flex_tablet_6": "o95yIq_flex_tablet_6",
});
